import { createIcon } from '../createIcon';

export const ResourcePoolIconConfig = {
  name: 'ResourcePoolIcon',
  height: 1024,
  width: 832,
  svgPath: 'M768,0 L64,0 C28.7,0 0,28.7 0,64 L0,768 C0,803.3 28.7,832 64,832 L61.5,1024 L765.5,1024 L765.5,832 C800.8,832 832,803.3 832,768 L832,64 C832,28.7 803.3,0 768,0 Z M192,957.4 L128,957.4 L128,829.4 L192,829.4 L192,957.4 Z M320,957.4 L256,957.4 L256,829.4 L320,829.4 L320,957.4 Z M448,957.4 L384,957.4 L384,829.4 L448,829.4 L448,957.4 Z M576,957.4 L512,957.4 L512,829.4 L576,829.4 L576,957.4 Z M639,320 L576,320 L576,384 L639,384 L639,448 L576,448 L576,512 L639,512 L639,576 L576,576 L576,640 L512,640 L512,576 L448,576 L448,640 L384,640 L384,576 L320,576 L320,640 L256,640 L256,576 L192,576 L192,512 L256,512 L256,448 L192,448 L192,384 L256,384 L256,320 L192,320 L192,256 L256,256 L256,192 L320,192 L320,256 L384,256 L384,192 L448,192 L448,256 L512,256 L512,192 L576,192 L576,256 L639,256 L639,320 Z M704,957.4 L640,957.4 L640,829.4 L704,829.4 L704,957.4 Z',
  yOffset: 0,
  xOffset: 0,
};

export const ResourcePoolIcon = createIcon(ResourcePoolIconConfig);

export default ResourcePoolIcon;